export function galleryScroller() {
    var gallery = document.querySelectorAll(".gallery-scroller");
    gallery.forEach(el => {
        var direction = "right";
        var circles = el.querySelector(".circles");
        var thumbnails = el.querySelector(".thumbnails");
        var galleryScroller = el.querySelector(".scroller");
        var currentIndex = 0;
        var intervalId;
        var startTimerTimoutId;
        var isAnimating;

        function init() {
            galleryScroller.addEventListener("scroll", scrollCallback);
            if (el.querySelector(".btn.next")) {
                el.querySelector(".btn.next").addEventListener("click", scrollNext);
            }
            if (el.querySelector(".btn.prev")) {
                el.querySelector(".btn.prev").addEventListener("click", scrollPrev);
            }
            createCircles();
            createThumbnails();
            scrollCallback();
            startTimer();
        }

        function scrollCallback() {
            stopInterval();
            if (el.querySelector(".btn.next")) {
                el.querySelector(".btn.next").classList.remove("hide");
            }
            if (el.querySelector(".btn.prev")) {
                el.querySelector(".btn.prev").classList.remove("hide");
            }

            var r = galleryScroller.getBoundingClientRect();
            for (let index = 0; index < galleryScroller.children.length; index++) {
                const child = galleryScroller.children[index];
                let childRect = child.getBoundingClientRect();
                let parentRect = galleryScroller.getBoundingClientRect();
                let left = childRect.left - parentRect.left;
                let width = childRect.width;
                let parentWidth = parentRect.width;
                let percentage = ((left + width / 2) / parentWidth + 0.5) * 100;
                if (percentage >= 50 && percentage <= 150) {
                    if (circles && circles.children.length > 0) {
                        circles.children[currentIndex].classList.remove("active");
                    }

                    if (thumbnails && thumbnails.children.length > 0) {
                        thumbnails.children[currentIndex].classList.remove("active");
                    }
                    currentIndex = index;
                }

                if (isLast() && el.querySelector(".btn.next")) {
                    el.querySelector(".btn.next").classList.add("hide");
                }

                if (isFirst() && el.querySelector(".btn.prev")) {
                    el.querySelector(".btn.prev").classList.add("hide");
                }
                if (circles && circles.children.length > 0) {
                    circles.children[currentIndex].classList.add("active");
                }

                if (thumbnails && thumbnails.children.length > 0) {
                    thumbnails.children[currentIndex].classList.add("active");
                }
            }
            clearTimeout(startTimerTimoutId)
            startTimerTimoutId = setTimeout(startTimer, 1000)
        }

        function scrollNext(e) {
            direction = "right";
            scrollToIndex(++currentIndex);
        }
        function scrollPrev(e) {
            direction = "left";
            scrollToIndex(--currentIndex);
        }

        function scrollToIndex(index) {
            if (isAnimating) {
                return;
            }
            index = index < 0 ? 0 : index;
            index = index >= galleryScroller.children.length ? galleryScroller.children.length - 1 : index;
            galleryScroller.classList.remove("snap");
            isAnimating = true;
            var speed = el.dataset.speed == undefined ? 500 : el.dataset.speed * 1000;
            animateProperty(galleryScroller, "scrollLeft", galleryScroller.children[index].offsetLeft, speed, () => {
                isAnimating = false;
                galleryScroller.classList.add("snap");
            });
        }

        function isFirst() {
            return currentIndex == 0;
        }

        function isLast() {
            return currentIndex >= galleryScroller.children.length - 1;
        }

        function timerCallback() {
            if (direction == "right") {
                if (isLast()) {
                    direction = "left";
                    timerCallback();
                } else {
                    scrollNext();
                }
            } else {
                if (isFirst()) {
                    direction = "right";
                    timerCallback();
                } else {
                    scrollPrev();
                }
            }
        }

        function createCircles() {
            if (!circles || galleryScroller.children.length == 1) {
                return;
            }
            for (let i = 0; i < galleryScroller.children.length; i++) {
                const div = document.createElement("div");
                circles.appendChild(div);
                if (i == 0) {
                    div.classList.add("active");
                }
                div.addEventListener("click", function (e) {
                    const index = Array.prototype.indexOf.call(circles.children, e.currentTarget);
                    currentIndex = index;
                    scrollToIndex(currentIndex);
                });
            }
        }

        function createThumbnails() {
            if (!thumbnails || galleryScroller.children.length == 1) {
                return;
            }
            for (let i = 0; i < galleryScroller.children.length; i++) {
                var child = galleryScroller.children[i];
                const div = document.createElement("button");
                thumbnails.appendChild(div);
                div.classList.add('thumbnail');
                div.innerHTML = '<img src="' + child.querySelector('img').getAttribute('src') + '" />'
                if (i == 0) {
                    div.classList.add("active");
                }
                div.addEventListener("click", function (e) {
                    const index = Array.prototype.indexOf.call(thumbnails.children, e.currentTarget);
                    currentIndex = index;
                    scrollToIndex(currentIndex);
                });
            }
        }

        function startTimer() {
            if (el.dataset.timer != undefined && galleryScroller.children.length > 1) {
                clearInterval(intervalId);
                intervalId = setInterval(timerCallback, el.dataset.timer * 1 * 1000);
            }
        }

        function stopInterval() {
            clearInterval(intervalId);
            intervalId = undefined;
        }

        init();
    });

    function easeInOutCubic(x) {
        return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
    }

    function animateProperty(object, property, endValue, duration, onComplete) {
        let startValue = object[property];
        let startTime = performance.now();

        function update(currentTime) {
            let elapsed = currentTime - startTime;
            let progress = easeInOutCubic(elapsed / duration);
            progress = Math.min(progress, 1);
            object.scrollLeft = startValue + (endValue - startValue) * progress;
            if (progress < 1) {
                requestAnimationFrame(update);
            } else if (onComplete) {
                onComplete();
            }
        }
        requestAnimationFrame(update);
    }
}